import { render } from "./ShowPersonalInfo.vue?vue&type=template&id=2f070e98&scoped=true"
import script from "./ShowPersonalInfo.vue?vue&type=script&lang=js"
export * from "./ShowPersonalInfo.vue?vue&type=script&lang=js"

import "./ShowPersonalInfo.vue?vue&type=style&index=0&id=2f070e98&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f070e98"]])

export default __exports__